import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Profile from './components/Profile';
import About from './components/About';
import Education from './components/Education';
import Career from './components/Career';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Resume from './components/Resume';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Profile />
      <About />
      <Education />
      <Career />
      <Experience />
      <Projects />
      <Contact />
      <Footer />
      <Resume />
    </div>
  );
}

export default App;
